import { useEffect, useState } from 'react';
const useHasAdBlock = () => {
    const [isAdblock, setIsAdblock] = useState(false);
  
    useEffect(() => {
      
    }, []);
  
    return isAdblock;
  };
  export default useHasAdBlock;